/* 
  Sends a custom "Cart Updated" event to Klaviyo with the FULL, current cart
  contents every time the cart changes — covering the gap between Klaviyo's
  native events: "Added to Cart" only carries the single item just added,
  and "Started Checkout" (the first native event with every line item) only
  fires once the customer actually reaches checkout. This lets an abandoned-
  cart flow trigger off "Cart Updated" and show every product the customer
  really had in their cart, even if they never started checkout at all.

  Uses klaviyo.track() (the onsite JS already loaded site-wide via the
  Klaviyo app embed), NOT the raw Events API used in back-in-stock.js — this
  is plain custom event tracking, which is exactly what klaviyo.track() is
  for, and it needs no public API key of its own. Per Klaviyo's own docs,
  this only does anything for a "known" (already-cookied/identified) visitor
  — which is fine here, since an anonymous visitor has no email to send an
  abandoned-cart email to in the first place.

  Scalable by construction: rather than hooking every individual "add to
  cart" button (quick-add, PDP, bundles, kiosk counter-checkout, and
  whatever gets added later), this intercepts window.fetch itself and
  reacts to ANY call to Shopify's cart endpoints — so a new add-to-cart
  surface added later is covered automatically, with no change needed here.

  /cart/add.js's own response is just the added line item (same limitation
  as the native event), so on every matched mutation this re-fetches
  /cart.js for the authoritative, complete cart before sending.
*/
(function () {
  // Every log from this file starts with this tag — filter the console by
  // it (type "[Klaviyo Cart]" in the console's filter box) to see only this.
  var LOG_TAG = '[Klaviyo Cart]';
  var CART_ENDPOINTS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

  function isCartMutation(url) {
    return CART_ENDPOINTS.some(function (path) { return url.indexOf(path) !== -1; });
  }

  function sendCartUpdated(cart) {
    if (!cart || !cart.items) return;

    if (!window.klaviyo || typeof window.klaviyo.track !== 'function') {
      console.warn(LOG_TAG, 'klaviyo.track no está disponible todavía (¿bloqueador de anuncios, o el embed de Klaviyo no ha cargado?) — evento NO enviado.');
      return;
    }

    var payload = {
      Items: cart.items.map(function (item) {
        return {
          ProductID: item.product_id,
          VariantID: item.variant_id,
          ProductName: item.product_title,
          VariantTitle: item.variant_title,
          Quantity: item.quantity,
          ItemPrice: item.price / 100,
          RowTotal: item.line_price / 100,
          ImageURL: item.image,
          ProductURL: item.url,
          SKU: item.sku
        };
      }),
      ItemCount: cart.item_count,
      TotalValue: cart.total_price / 100,
      Currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
    };

    // klaviyo.track() only does anything for a visitor Klaviyo has already
    // cookied/identified (login, newsletter signup, previous order...) — an
    // anonymous visitor silently gets nothing sent, by Klaviyo's own design.
    // isIdentified() surfaces that BEFORE we call track(), since track()
    // resolving below doesn't tell you this on its own.
    if (typeof window.klaviyo.isIdentified === 'function') {
      window.klaviyo.isIdentified().then(function (identified) {
        if (!identified) {
          console.warn(LOG_TAG, 'Este visitante NO está identificado por Klaviyo todavía (sin login, sin formulario rellenado...) — aunque track() se complete, Klaviyo no asociará el evento a ningún perfil con email.');
        }
      });
    }
    
    console.log(LOG_TAG, 'Enviando evento "Cart Updated" a Klaviyo con payload:', payload);

    window.klaviyo.track('Cart Updated', payload)
      .then(function () {
        console.log(LOG_TAG, 'Klaviyo confirmó la recepción del evento "Cart Updated":', payload);
      })
      .catch(function (err) {
        console.warn(LOG_TAG, 'track() fue RECHAZADO por Klaviyo — el evento no llegó:', err);
      });
  }

  function refreshAndSend(matchedUrl) {
    console.log(LOG_TAG, 'Mutación de carrito detectada en', matchedUrl, '— pidiendo /cart.js actualizado...');
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (cart) {
          sendCartUpdated(cart);
        } else {
          console.warn(LOG_TAG, '/cart.js no respondió OK — evento no enviado.');
        }
      })
      .catch(function (err) {
        console.warn(LOG_TAG, 'Error al pedir /cart.js:', err);
      });
  }

  var originalFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = originalFetch.apply(this, arguments);
    if (isCartMutation(url)) {
      result.then(function (res) {
        if (res && res.ok) {
          refreshAndSend(url);
        } else {
          console.warn(LOG_TAG, 'La llamada a', url, 'no fue OK (status ' + (res && res.status) + ') — no se envía evento.');
        }
      }).catch(function (err) {
        console.warn(LOG_TAG, 'Error en la llamada a', url, ':', err);
      });
    }
    return result;
  };

  console.log(LOG_TAG, 'Script cargado y escuchando mutaciones de carrito.');
})();
